import {ImageSourceType} from '@models/pages/user-defined-page/user-defined-chart-details';

export class ImageDetails {
  bucketPath: string = '';
  imageSourceType: ImageSourceType | undefined;
  imageNameOrMetaKey: string = '';
  imageContent: string = '';

  constructor(bucketPath: string, imageSourceType: ImageSourceType, imageNameOrMetaKey: string, imageContent: string) {
    this.bucketPath = bucketPath;
    this.imageSourceType = imageSourceType;
    this.imageNameOrMetaKey = imageNameOrMetaKey;
    this.imageContent = imageContent;
  }
}